import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #101d40;

      span {
        font-weight: 600;
      }
    }
  }

  .body {
    margin: 0 auto;
    min-width: 280px;
    max-width: 300px;

    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;
